<template>
  <el-popover
    placement="bottom-start"
    width="500"
    trigger="click"
    popper-class="ips-org-tree__popper"
    v-model="visible"
  >
    <el-input
      slot="reference"
      v-model="name"
      :clearable="true"
      class="ips-org-tree__input name"
      :placeholder="placeholder"
      @change="handleChange"
      @input="handleInput"
      @click.native="handleClick"
    ></el-input>
    <div class="ips-org-tree__tree-container" ref="tree-container" v-loading="loading">
      <div class="grid_container container">
           <el-row :gutter="2" v-for="(item) in gridData.data" :key="item.staffId"  :class="{'hoverBg':hoverIndex==item.staffId}" @ @mouseover.native="hoverIndex=item.staffId"
            @click.native="handleHide(item)">
              <el-col :span="2">{{item.staffName}}</el-col>
               <el-col :span="20">{{item.fullName}}</el-col>
           </el-row>
      </div>
    </div>
  </el-popover>
</template>

<script>
import BScroll from "better-scroll";
import { PAGE_LAYOUT, PAGE_SIZES, SCROLL_CONFIG} from "../../store/constant";

/**
   * 员工树和列表的混合组件
   * TODO
   */
  export default {
    name: "staffDropTree",
    props: {
      showCheckBox: Boolean,
      placeholder: String,
      disabled: Boolean,
      projectId: String,
      name:String
    },
    data() {
      return {
        PAGE_LAYOUT,
        PAGE_SIZES,
        visible: false,
        gridData: [],
        loading: false,
        hoverIndex:null,
        staffObject:{},
      };
    },
    computed: {},
    methods: {
      handleHide(val) {
        this.staffObject={...val}
        this.name=this.staffObject.staffName
        this.$emit("after-handleHide",this.staffObject);
        this.visible = false;
        // console.log(this.name)
      }
      , handleClick() {
        this.visible = true;

      }
      , handleChange() {
        // if (utils.isEmpty(this.name)) {
        //   this.$emit("change", {});
        //   this.$emit("update:id", "");
        //   this.$emit("update:name", "");
        // }
      }
      , handleInput() {
        this.visible = true;
        this.$store.dispatch('housebindstaff/getStaff',this.name).then(res=>{
          this.gridData=res
        })

      },
      clear() {
        this.finish({})
      }
    },
    mounted() {
      new BScroll(this.$refs["tree-container"], SCROLL_CONFIG);
    }
  };
</script>

<style lang="scss">
  @import "../../assets/scss/dropTree.scss";
  .hoverBg{
    color: #38A9E4;
     font-size: 12px;
  }
  .container{
    font-size: 12px;
  }
</style>
